<template>
  <action-menu-wrapper-v2
    :items="types"
    teleport
    :offset="{ top: 5, left: 0 }"
    close-menu-on-trigger-hide
  >
    <template #trigger="{ showMenu }">
      <div class="flex items-center space-x-2" data-cy="text-type-selector">
        <span class="text-headline-new">{{ activeTab }}</span>
        <icon-base
          :icon="IconCaretDown"
          class="transform text-label"
          :class="{ 'rotate-180': showMenu }"
        />
      </div>
    </template>
  </action-menu-wrapper-v2>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

import IconCaretDown from "@/components/icons/deals/IconCaretDown.vue";
import ActionMenuWrapperV2 from "@/components/ui/ActionMenuWrapperV2.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { MenuItem } from "@/components/ui/ActionMenuWrapperV2.vue";

const { activeTab } = defineProps<{
  activeTab: string;
}>();

const { t } = useI18n();

const emit = defineEmits<{ click: [string] }>();

const types: MenuItem[] = [
  {
    label: t("COMMON.NOTE"),
    handler: () => emit("click", t("COMMON.NOTE")),
  },
  {
    label: t("COMMON.SUMMARY"),
    handler: () => emit("click", t("COMMON.SUMMARY")),
  },
  {
    label: t("COMMON.TRANSCRIPTION"),
    handler: () => emit("click", t("COMMON.TRANSCRIPTION")),
  },
];
</script>
